import { NgModule } from '@angular/core';

import { LegacyUsersService } from './services/legacy-users.service';
import { SignatureService } from './services/signature.service';

@NgModule({ providers: [LegacyUsersService, SignatureService] })
export class AccountMigrationServicesModule {}
